import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { DIALOG_TYPE, DOCUMENT_TYPE, LANGUAGE, PRODUCT_TYPE } from '../../../define/global';

import IcoFileHwp from '../../../img/ico_file_32_hwp.png';
import IcoFileHwp2x from '../../../img/ico_file_32_hwp@2x.png';
import IcoFileSheet from '../../../img/ico_file_32_sheet.png';
import IcoFileSheet2x from '../../../img/ico_file_32_sheet@2x.png';
import IcoFileSlide from '../../../img/ico_file_32_slide.png';
import IcoFileSlide2x from '../../../img/ico_file_32_slide@2x.png';
import IcoFileWord from '../../../img/ico_file_32_word.png';
import IcoFileWord2x from '../../../img/ico_file_32_word@2x.png';

import FloatingTitleEn from '../../../img/popup_floating_title_en.png';
import FloatingTitleEn2x from '../../../img/popup_floating_title_en@2x.png';
import FloatingTitleKr from '../../../img/popup_floating_title_kr.png';
import FloatingTitleKr2x from '../../../img/popup_floating_title_kr@2x.png';

import FloatingArrowHwp from '../../../img/popup_floating_arrow_hwp.png';
import FloatingArrowHwp2x from '../../../img/popup_floating_arrow_hwp@2x.png';
import FloatingArrowSheet from '../../../img/popup_floating_arrow_sheet.png';
import FloatingArrowSheet2x from '../../../img/popup_floating_arrow_sheet@2x.png';
import FloatingArrowSlide from '../../../img/popup_floating_arrow_slide.png';
import FloatingArrowSlide2x from '../../../img/popup_floating_arrow_slide@2x.png';

import FloatingClose from '../../../img/popup_floating_close.png';
import FloatingClose2x from '../../../img/popup_floating_close@2x.png';
import FloatingCloseEdu from '../../../img/popup_floating_close_edu_b2b.png';
import FloatingCloseEdu2x from '../../../img/popup_floating_close_edu_b2b@2x.png';

import { getLanguage, useArrangeButtonOrder, useLinkEditorUrl } from '../../../utils/util';
import { noTextSelect } from '../../common/CssCommon';
import { useState } from 'react';
import { useAppDataSliceSelector } from '../../../store/modules/appData';

const Wrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 186px;
  height: ${({ wrapperHeight }) => wrapperHeight && wrapperHeight}px;
`;

const WrapperBG = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  background-color: #393939;
  opacity: 0.5;
`;

const WrapperContents = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const HomeButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const HomeButton = styled.div`
  flex: 1;
  width: 166px;
  min-height: 48px;
  margin-top: 3px;
  border-radius: 3.6px;
  box-shadow: 1px 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #e4f6ff;

  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  padding-left: 4px;

  ${({ cssExt }) => cssExt && cssExt}
  cursor:pointer;
  ${noTextSelect}
  &+& {
    margin-top: 6px;
  }
`;

const HomeButtonHwpBgColor = css`
  background-color: #e4f6ff;
  color: #002d64;
`;

const HomeButtonSheetBgColor = css`
  background-color: #eafdcd;
  color: #133500;
`;

const HomeButtonSlideBgColor = css`
  background-color: #fff2e0;
  color: #26231f;
`;

const HomeButtonContents = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
`;

const HomeButtonFormatName = styled.div`
  font-size: 15px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.53px;
  margin-left: 4px;
  display: flex;
  flex-direction: row;
  align-items: baseline;

  ${({ color }) => color && color}
`;

const HomeButtonTail = styled.div`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.4px;
  margin-left: 4px;
`;

const CloseButton = styled.div`
  position: absolute;
  right: 0px;
  top: 0px;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ArrowWrapper = styled.div`
  margin-right: 11px;
`;

const PaddingArea = styled.div`
  min-height: 38px;
`;

const ArrowImg = styled.img``;

export default function FloatingHomeButtonMobile() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(true);
  const language = getLanguage(i18n.language);
  const appData = useAppDataSliceSelector();
  const linkEditorUrl = useLinkEditorUrl();
  const arrangeButtonOrder = useArrangeButtonOrder();

  if (!open) return null;
  const floatingImg =
    language === LANGUAGE.KO
      ? { src: FloatingTitleKr, srcSet: FloatingTitleKr2x }
      : { src: FloatingTitleEn, srcSet: FloatingTitleEn2x };

  const homeButtons = arrangeButtonOrder([
    {
      type: DOCUMENT_TYPE.HWP,
      icon: { src: IcoFileHwp, srcSet: IcoFileHwp2x },
      arrow: { src: FloatingArrowHwp, srcSet: FloatingArrowHwp2x },
      i18nID: 'HomeButton.WebHwp',
      cssExt: HomeButtonHwpBgColor
    },
    {
      type: DOCUMENT_TYPE.SHEET,
      icon: { src: IcoFileSheet, srcSet: IcoFileSheet2x },
      arrow: { src: FloatingArrowSheet, srcSet: FloatingArrowSheet2x },
      i18nID: 'HomeButton.WebSheet',
      cssExt: HomeButtonSheetBgColor
    },
    {
      type: DOCUMENT_TYPE.SLIDE,
      icon: { src: IcoFileSlide, srcSet: IcoFileSlide2x },
      arrow: { src: FloatingArrowSlide, srcSet: FloatingArrowSlide2x },
      i18nID: 'HomeButton.WebSlide',
      cssExt: HomeButtonSlideBgColor
    },
    {
      type: DOCUMENT_TYPE.WORD,
      icon: { src: IcoFileWord, srcSet: IcoFileWord2x },
      arrow: { src: FloatingArrowHwp, srcSet: FloatingArrowHwp2x },
      i18nID: 'HomeButton.WebWord',
      cssExt: HomeButtonHwpBgColor
    }
  ]);

  const closeButtonImage =
    appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE
      ? { src: FloatingClose, srcSet: FloatingClose2x }
      : { src: FloatingCloseEdu, srcSet: FloatingCloseEdu2x };

  const componentTemplate = ({ type, icon, arrow, i18nID, cssExt }) => {
    return (
      <HomeButton
        cssExt={cssExt}
        key={type}
        onClick={() => linkEditorUrl(type, DIALOG_TYPE.DIALOG_OPEN_DOCUMENT)}>
        <img width="32px" height="32px" src={icon.src} srcSet={icon.srcSet} alt={t(i18nID)} />
        <HomeButtonContents>
          {language === LANGUAGE.KO ? (
            <HomeButtonFormatName>
              {t(i18nID)}
              <HomeButtonTail>{t('HomeButton.LinkDirect')}</HomeButtonTail>
            </HomeButtonFormatName>
          ) : (
            <>
              <HomeButtonFormatName>{t(i18nID)}</HomeButtonFormatName>
              <ArrowWrapper>
                <ArrowImg width="7px" height="10px" src={arrow.src} srcSet={arrow.srcSet} />
              </ArrowWrapper>
            </>
          )}
        </HomeButtonContents>
      </HomeButton>
    );
  };
  // menu height + menu padding + image height + top/bottom padding
  const wrapperHeight = homeButtons.length * 48 + (homeButtons.length - 1) * 6 + 66 + 10;

  return (
    <Wrapper wrapperHeight={wrapperHeight}>
      {appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE && <WrapperBG />}
      <WrapperContents>
        {appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE ? (
          <img
            width="186px"
            height="62px"
            src={floatingImg.src}
            srcSet={floatingImg.srcSet}
            alt="Floating Title"
          />
        ) : (
          <PaddingArea />
        )}
        <HomeButtons>
          {homeButtons.map((btn) => {
            return componentTemplate(btn);
          })}
        </HomeButtons>
        <CloseButton onClick={() => setOpen(false)}>
          <img
            width="18px"
            height="18px"
            alt="Floating Close"
            src={closeButtonImage.src}
            srcSet={closeButtonImage.srcSet}
            style={{ color: 'red' }}
          />
        </CloseButton>
      </WrapperContents>
    </Wrapper>
  );
}
